<template>
  <div class="third">
    <component :is="labelName" :ref="labelName" :ID="slideshow" @backHome="goBackHome" @add="toAddRole"></component>
  </div>
</template>

<script>
import MYZOE from './components/MYZOE-manage.vue';
import datacards from './components/datacards-manage.vue';

export default {
  name: 'YXindex',
  data() {
    return {
      labelName: 'MYZOE',
      slideshow:null
    }
  },
  components: {
    MYZOE,
    datacards
  },
  created() {
  },
  methods: {
    // 返回首页
    goBackHome() {
      this.labelName = 'MYZOE'
    },
    // 新增/编辑
    toAddRole(val) {
      this.labelName = 'datacards'
      console.log("获取",val)
      this.slideshow = val
    },
  },
}
</script>
